import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 3000 },
  };

  connect() {
    this.timer = window.setInterval(() => {
      Turbo.visit(window.location.href);
    }, this.intervalValue);
  }

  disconnect() {
    window.clearInterval(this.timer);
    this.timer = null;
  }
}
